export enum StatusMessageBox{
    DataCollection = 0,
    ReadyForRefinement = 1,
    OneRefinementCompleted = 2,
    ReadyForTraining = 3,
    TrainingInProgress = 4,
    TrainingCompleted = 5,
    ProjectStopped = 6,
    ProjectError = 7
}

export enum ProjectFlowPhase{
    WaitingForImages = 0,
    Cluster = 1,
    Training = 2,
    Done = 3,
    Error = 4,
    Stopped = 5,
    TrainingReady = 6,
    ManualRefinement = 7
}

export const ClassFlowPhase = {
    InCluster: 0,
    ManualRefinementReady: 1,
    ManualRefinementProcessPending: 2,
    TrainingReady: 3,
    OnHold: 4,
    Error: 5,
    Stopped: 6,
    Training: {
        InProgress: 0,
        Completed: 1,
        Canceled: 2,
        Error: 3,
        ProcessCancelRequest: 4,
        NotStarted: 5,
        Draft: 6,
    }
};

export enum ChipStyle{
    CollectingImages = 0,
    ReadyForMr = 1,
    ReadyForTraining = 2,
    Error = 3

}


export enum TrainingTypes{
    Classification= 0
}

export enum FeatureVersionStatus{
    InProgress = 'InProgress',
    Completed = 'Completed',
    Canceled = 'Canceled',
    Error = 'Error',
    ProcessCancelRequest = 'ProcessCancelRequest',
    NotStarted = 'NotStarted',
    Draft = 'Draft'
}
